<script>
  export default {
    props: {
      formDataUrl: {
        type: String,
        default: null,
      },
      initialFormData: {
        type: Object,
        default: function () {
          return {};
        }
      }
    },

    data() {
      return {
        formData: null,
      };
    },

    computed: {
      isInitialized() {
        return !_.isNull(this.formData);
      }
    },

    methods: {
      /**
       * @property {string|null} url
       * @return {undefined}
       */
      getFormData(url = null) {
        if (!url) {
          this.formData = this.initialFormData;

          return;
        }

        axios.get(url)
          .then(this.onFormDataReceived)
          .catch(this.onFormDataReceiveError);
      },

      /**
       * @return {undefined}
       */
      onFormDataReceived({data}) {
        this.formData = data;
      },

      /**
       * @return {undefined}
       */
      onFormDataReceiveError(error) {
        this.notifyFormDataReceiveError(error);
      },

      /**
       * @return {undefined}
       */
      notifyFormDataReceiveError(error) {
        const message = _.get(error, 'response.data.message');
        if (_.isString(message)) {
          this.$message.error(message);
        }
      },

      /**
       * @return {undefined}
       */
      onMounted() {
        this.getFormData(this.formDataUrl);
      }
    },

    mounted() {
      this.onMounted();
    }
  }
</script>
